
const config = {
    selectors: {
        root: '.lightbox-slider',
        body: 'body',
        lightbox: '.lightbox-slider__lightbox',
        lightboxSlides: '.lightbox-slider__lightbox-slides',
        lightboxSlide: '.lightbox-slider__lightbox-slide',
        lightboxNext: '.lightbox-slider__lightbox-next',
        lightboxPrev: '.lightbox-slider__lightbox-prev',
        closeBtn: '.lightbox-slider__close-btn',
        backBtn: '.lightbox-slider__back',
        ccBtn: '.lightbox-slider__subtitle-btn',
        videoFullscreenBtn: '.lightbox-slider__expand-btn',
        video: '.video-js',
        videoControls: '.video__controls',
        playPauseBtn: '.video__play-pause',
        seekslider: '.video__seekslider',
        currentTime: '.video__currentTime',
        durationTime: '.video__durationTime',
        volume: '.video__volume',
        fullscreen: '.video__fullscreen',
        captions: '.video__captions',
        thumbnail: '.video__thumbnail',
        thumbnailTimer: '.video__thumbnail-timer',

        volumeMute: '.video__volume--mute',
        volume25: '.video__volume--25',
        volume50: '.video__volume--50',
        volume75: '.video__volume--75',
        volume100: '.video__volume--100',
    },
    classNames: {
        noScroll: 'no-scroll',
        lightboxVisible: 'lightbox-slider__lightbox--visible',
    },
    dataAttributes: {

    },
    mainSliderConfig: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        centerMode: true,
        centerPadding: '16.66%',
    },
    previewSliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
    },
};

export class LightboxSlider {
    static $el = null;

    static create(items, captions) {
        const html = LightboxSlider._createHtml(items, captions);
        $('body').append(html);
        const $rootElement = $(config.selectors.root);
        LightboxSlider.$el = $rootElement;
        const $elements = LightboxSlider._getDomElements($rootElement);
        LightboxSlider._addEventListeners($elements);
        $elements.$lightboxSlides.slick(config.mainSliderConfig);
        LightboxSlider._initVideos($elements.$video, $elements.$videoControls);
    }

    static _getDomElements($rootElement) {
        return {
            $body: $(config.selectors.body),
            $lightbox: $rootElement.find(config.selectors.lightbox),
            $lightboxSlides: $rootElement.find(config.selectors.lightboxSlides),
            $lightboxSlide: $rootElement.find(config.selectors.lightboxSlide),
            $lightboxNext: $rootElement.find(config.selectors.lightboxNext),
            $lightboxPrev: $rootElement.find(config.selectors.lightboxPrev),
            $closeBtn: $rootElement.find(config.selectors.closeBtn),
            $backBtn: $rootElement.find(config.selectors.backBtn),
            $playPauseBtn: $rootElement.find(config.selectors.playPauseBtn),
            $volumeBtn: $rootElement.find(config.selectors.volumeBtn),
            $ccBtn: $rootElement.find(config.selectors.ccBtn),
            $videoFullscreenBtn: $rootElement.find(config.selectors.videoFullscreenBtn),
            $video: $rootElement.find(config.selectors.video),
            $videoControls: $rootElement.find(config.selectors.videoControls),
            $seekslider: $rootElement.find(config.selectors.seekslider),
            $currentTime: $rootElement.find(config.selectors.currentTime),
            $durationTime: $rootElement.find(config.selectors.durationTime),
            $fullscreen: $rootElement.find(config.selectors.fullscreen),
            $captions: $rootElement.find(config.selectors.captions),
            $volume: $rootElement.find(config.selectors.volume),
            $volumeMute: $rootElement.find(config.selectors.volumeMute),
            $volume25: $rootElement.find(config.selectors.volume25),
            $volume50: $rootElement.find(config.selectors.volume50),
            $volume75: $rootElement.find(config.selectors.volume75),
            $volume100: $rootElement.find(config.selectors.volume100),
            $thumbnail: $rootElement.find(config.selectors.thumbnail),
            $thumbnailTimer: $rootElement.find(config.selectors.thumbnailTimer),
        };
    }

    static _addEventListeners(elements) {
        const _this = this;

        elements.$lightboxNext.on('click', () => {
            elements.$lightboxSlides.slick('slickNext');
        });

        elements.$lightboxPrev.on('click', () => {
            elements.$lightboxSlides.slick('slickPrev');
        });


        elements.$closeBtn.on('click', () => {
            LightboxSlider.$el.remove();
            elements.$body.removeClass(config.classNames.noScroll);
        });

        elements.$backBtn.on('click', () => {
            LightboxSlider.$el.remove();
            elements.$body.removeClass(config.classNames.noScroll);
        });

        elements.$playPauseBtn.on('click', () => {
            const index = elements.$lightboxSlides.slick('slickCurrentSlide');

            const videoSlide = elements.$lightboxSlide;
            const video = $(videoSlide[index]).find(config.selectors.video)[0];

            LightboxSlider._playPauseVideo(video)

        });

        elements.$seekslider.on('change', () => {
            const index = elements.$lightboxSlides.slick('slickCurrentSlide');

            const videoSlide = elements.$lightboxSlide;
            const video = $(videoSlide[index]).find(config.selectors.video)[0];

            const seekTo = video.player.duration() * (this._elements.$seekslider[0].value / 100);
            video.player.currentTime(seekTo);
        })

        elements.$volume.on('click', (e) => {
            const index = elements.$lightboxSlides.slick('slickCurrentSlide');

            const videoSlide = elements.$lightboxSlide;
            const video = $(videoSlide[index]).find(config.selectors.video)[0];
            const volumeMute = $(videoSlide[index]).find(config.selectors.volumeMute)[0]
            const volume25 = $(videoSlide[index]).find(config.selectors.volume25)[0]
            const volume50 = $(videoSlide[index]).find(config.selectors.volume50)[0]
            const volume75 = $(videoSlide[index]).find(config.selectors.volume75)[0]
            const volume100 = $(videoSlide[index]).find(config.selectors.volume100)[0]
            const volumeValue = e.currentTarget.value / 100;
            if (video.player.volume() === 0) {
                video.player.volume(0.25);
                $(volumeMute).hide();
                $(volume25).show();
            } else if (video.player.volume() === 0.25) {
                video.player.volume(0.5);
                $(volume25).hide();
                $(volume50).show();
            } else if (video.player.volume() === 0.50) {
                video.player.volume(0.75);
                $(volume50).hide();
                $(volume75).show();
            } else if (video.player.volume() === 0.75) {
                video.player.volume(1);
                $(volume75).hide();
                $(volume100).show();
            } else if (volumeValue === 1) {
                video.player.volume(0);
                $(volume100).hide();
                $(volumeMute).show();
            }
        })

        elements.$fullscreen.on('click', () => {
            
        });
    }

    static _playPauseVideo(video) {
        if (video.player.paused()) {
            video.player.play();
        } else {
            video.player.pause();
        }
    }

    static _initVideos(videos, videoControls) {
        videos.each((index, element) => {
            bc(element);
        })

        videoControls.removeClass('video__controls--hidden');


    }

    static _createItemHtml(items, captions) {
        let html = '';

        for (let i = 0; i < items.length; i++) {
            html += `
                <div class="lightbox-slider__lightbox-slide">
                    <div class="lightbox-slider__headline">
                        <div class="lightbox-slider__caption">
                            ${captions[i]}
                        </div>
                        <div class="lightbox-slider__back">
                            Back
                            <span class="lightbox-slider__back-icon icon-TickCircleForwardSmall1"></span>
                        </div>
                    </div>
                    <div class="lightbox-slider__lightbox-slide-visual">
                        ${items[i]}
                    </div>
                </div>
            `;
        };

        return html;
    }

    static _createHtml(items, captions) {
        return `
            <div class="lightbox-slider">
                <div class="lightbox-slider__lightbox">
                    <div class="lightbox-slider__lightbox-inner">
                        <div class="lightbox-slider__lightbox-slides">
                            ${this._createItemHtml(items, captions)}
                        </div>
                        <span class="lightbox-slider__lightbox-prev icon-StateDark3"></span>
                        <span class="lightbox-slider__lightbox-next icon-StateDark16"></span>
                        <span class="lightbox-slider__close-btn icon-arrowShrink"></span>
                    </div>
                </div>
            </div>
        `;
    }
}
